// extracted by mini-css-extract-plugin
export default {"subscribe":"subscribe_SL1nJ"};